// Design tokens for the Magic Studio module.
// Mirrors the Asset Lab brand palette from the Claude Design handoff
// (Noto Sans, primary blue #1862D1). Centralised here so the studio's
// custom visual styling stays consistent and easy to retheme later.
export const TM = {
  blue: '#1862D1',
  blueDark: '#134EA7',
  blueLight: '#D1E0F6',
  blueFaint: '#E8F0FB',
  blueWash: '#F3F7FC',
  text: '#2D2D2D',
  textMute: '#575757',
  textFaint: '#969696',
  bg: '#FFFFFF',
  bgSoft: '#F4F4F4',
  border: '#EAEAEA',
  borderStrong: '#D5D5D5',
  green: '#09AC2D',
  greenSoft: '#B3DBBC',
  orange: '#FF3D00',
  shadow: '0 2px 8px rgba(45,45,45,0.06)',
  magicGradient: 'linear-gradient(135deg, #1862D1 0%, #2D8BE8 60%, #6B5BD1 100%)',
} as const;
